/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Footer from "./footer"
import Header from "./header"
import SideBar from "./sidebar"
// import ScrollArrow from "../Features/scrollTop"
import { Row, Col } from "reactstrap"

import "../../styles/index.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className="row-header">
      {/* <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      ></link> */}
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div className="pl-4 pr-2" id="content">
        <Row style={{ marginTop: "90px" }}>
          <Col md="8">
            <main>{children}</main>
          </Col>
          <Col md="4">
            <SideBar />
          </Col>
        </Row>
      </div>
      {/* <ScrollArrow /> */}
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
